module.exports = __webpack_public_path__ + "media/images/article/2021_04-8d45322a674659aa220d33c07cd43a96.png";